/**
 * `GET /admin/sdrs` — 2026-09-24 (user request): dropdown source for the
 * "Carteira SDR" filter in `Conversations.tsx` (was a free-text UUID input,
 * now a proper `<Select>`, same treatment as the "Vendedor" filter next to
 * it, which already used `GET /admin/sellers`).
 *
 * Deliberately minimal — just `{id, name}` — mirrors `SellerListResponse`,
 * not the full `User` shape (no email/role/active noise a dropdown doesn't
 * need).
 */
import { Type } from '@sinclair/typebox';
export const SdrOption = Type.Object({
    id: Type.String({ format: 'uuid' }),
    name: Type.String(),
});
export const SdrListResponse = Type.Object({
    sdrs: Type.Array(SdrOption),
});
//# sourceMappingURL=sdrs.js.map